import React from 'react'
import {
  Dialog,
  DialogContent,
  Button,
  Typography,
  Box,
  IconButton,
  makeStyles
} from '@material-ui/core'
import { Close as CloseIcon } from '@material-ui/icons'
import DialogActions from '@material-ui/core/DialogActions'
import { CountNumber } from './ImportSummaryModal'

const OrganizationImportSummaryModal = ({ open, onClose, summary }) => {
  const classes = useStyles()

  return (
    <Dialog open={open} maxWidth="md" fullWidth classes={{ paper: classes.dialogPaper }}>
      <Box className={classes.dialogTitle}>
        <Typography variant="h5">Import Summary</Typography>
        <IconButton onClick={onClose} size="small" className={classes.closeButton}>
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent className={classes.dialogContent}>
        <Box className={classes.summaryContainer}>
          <Box className={classes.summaryItem}>
            <Box className={classes.summaryIconSuccess}>
              <CountNumber value={summary.uniqueCount} className={classes.summaryNumber} />
            </Box>
            <Box className={classes.summaryTextContainer}>
              <Typography className={classes.summaryText}>
                Organization(s) successfully imported
              </Typography>
            </Box>
          </Box>

          <Box className={classes.summaryItem}>
            <Box className={classes.summaryIconSkipped}>
              <CountNumber value={summary.existingCount} className={classes.summaryNumber} />
            </Box>
            <Box className={classes.summaryTextContainer}>
              <Typography className={classes.summaryText}>
                Organization(s) skipped due to existing names
              </Typography>
            </Box>
          </Box>

          {summary.invalidLevelsCount > 0 && (
            <Box className={classes.summaryItem}>
              <Box className={classes.summaryIconWarning}>
                <CountNumber value={summary.invalidLevelsCount} className={classes.summaryNumber} />
              </Box>
              <Box className={classes.summaryTextContainer}>
                <Typography className={classes.summaryText}>
                  Organization(s) with level set to default &ldquo;{summary.defaultLevel}&rdquo;
                </Typography>
              </Box>
            </Box>
          )}
        </Box>

        <DialogActions className={classes.buttonBox}>
          <Button
            onClick={onClose}
            variant="contained"
            color="primary"
            className={classes.okButton}>
            OK
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}

const useStyles = makeStyles({
  dialogPaper: {
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 8px 24px rgba(0,0,0,0.1)'
  },
  dialogTitle: {
    borderBottom: '1px solid #f0f0f0',
    padding: '20px 24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& h5': {
      fontWeight: 600,
      fontSize: '20px',
      color: '#2c3e50'
    }
  },
  closeButton: {
    color: '#757575'
  },
  dialogContent: {
    padding: '24px 24px 16px'
  },
  summaryContainer: {
    padding: '8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  },
  summaryTitle: {
    fontWeight: 600,
    color: '#2c3e50',
    marginBottom: '8px',
    textAlign: 'center'
  },
  summaryItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '16px',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px'
  },
  summaryIconSuccess: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '70px',
    height: '70px',
    borderRadius: '50%',
    backgroundColor: 'rgba(46, 204, 113, 0.15)',
    border: '2px solid #2ecc71',
    flexShrink: 0,
    padding: '4px'
  },
  summaryIconSkipped: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '70px',
    height: '70px',
    borderRadius: '50%',
    backgroundColor: 'rgba(3, 169, 244, 0.15)',
    border: '2px solid #03a9f4',
    flexShrink: 0,
    padding: '4px'
  },
  summaryIconWarning: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '70px',
    height: '70px',
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 152, 0, 0.15)',
    border: '2px solid #ff9800',
    flexShrink: 0,
    padding: '4px'
  },
  summaryNumber: {
    marginBottom: '4px',
    fontWeight: 600,
    color: '#2c3e50',
    display: 'block',
    width: '100%',
    textAlign: 'center'
  },
  summaryTextContainer: {
    flex: 1
  },
  summaryText: {
    fontSize: '16px',
    fontWeight: 500,
    color: '#455a64'
  },
  buttonBox: {
    marginTop: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    padding: '16px 0'
  },
  okButton: {
    padding: '8px 40px',
    fontWeight: 600
  }
})

export default OrganizationImportSummaryModal
